import { render } from "./YourDetailsPB1.vue?vue&type=template&id=ac00bcc4&scoped=true"
import script from "./YourDetailsPB1.vue?vue&type=script&lang=js"
export * from "./YourDetailsPB1.vue?vue&type=script&lang=js"

import "./YourDetailsPB1.vue?vue&type=style&index=0&id=ac00bcc4&lang=scss"
import "./YourDetailsPB1.vue?vue&type=style&index=1&id=ac00bcc4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac00bcc4"]])

export default __exports__